import { createReducer, on } from '@ngrx/store';
import { initialState } from './list-evidence-store.state';
import * as ListEvidenceActions from './list-evidence-store.actions';

export const listEvidenceReducer = createReducer(
  initialState,
  on(ListEvidenceActions.listEvidenceSuccess, (state, result) => ({
    ...state,
    evidence: result.evidence,
    count: result.count,
    query: result.query,
    isLoadingEvidenceList: false,
  })),
  on(ListEvidenceActions.listEvidence, (state) => ({
    ...state,
    isLoadingEvidenceList: true,
  })),
  on(ListEvidenceActions.sharedWithMeEvidenceSuccess, (state, result) => ({
    ...state,
    sharedWithMeEvidence: result.evidenceSharedWithMe,
    sharedWithMeCount: result.sharedWithMeCount,
    isLoadingSharedWithMe: false,
  })),
  on(ListEvidenceActions.sharedWithMeEvidence, (state) => ({
    ...state,
    isLoadingSharedWithMe: true,
  }))
);
